import { render, staticRenderFns } from "./start-session.vue?vue&type=template&id=273e969d&scoped=true&"
import script from "./start-session.vue?vue&type=script&lang=ts&"
export * from "./start-session.vue?vue&type=script&lang=ts&"
import style0 from "./start-session.vue?vue&type=style&index=0&id=273e969d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273e969d",
  null
  
)

export default component.exports